import React, { SetStateAction, useEffect, useRef, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import DocumentTab from "./DocumentTab";
import WebsiteTab from "./WebsiteTab";
import CsvTab from "./CsvTab";
import JsonTab from "./JsonTab";
import CombinedTab from "./CombinedTab";
import {
  KnowledgeBase,
  KnowledgeBaseCombine,
  knowledgeDoc,
  KnowledgeWebsite,
} from "../../../Shared-ui/Types/KnowledgeBase";
import { use } from "marked";
import { KnowledgeBaseTypeEnum } from "../../../Shared-ui/Enum/KnowledgeBaseEnum";

interface MyComponentProps {
  setKnowledgeBase: React.Dispatch<SetStateAction<KnowledgeBase>>;
  knowledgeBase: KnowledgeBase;
  knowledgeBaseDoc: knowledgeDoc;
  setKnowledgeBaseDoc: React.Dispatch<SetStateAction<knowledgeDoc>>;
  setKnowledgeBasWebsite: React.Dispatch<SetStateAction<KnowledgeWebsite>>;
  setKnowledgeBaseCombine: React.Dispatch<SetStateAction<KnowledgeBaseCombine>>;
  knowledgeBaseCombine: KnowledgeBaseCombine;
}

const KnowledgeBaseTabs: React.FC<MyComponentProps> = (props) => {
  const knowledgeBaseType: Record<number, string> = {
    0: KnowledgeBaseTypeEnum.PDF,
    1: KnowledgeBaseTypeEnum.WEBSITE,
    2: KnowledgeBaseTypeEnum.COMBINED,
  };
  const [activeTab, setActiveTab] = useState(0);
  const currentTab = useRef(activeTab);
  const [tabDisable, setTabDisable] = useState({
    document: false,
    website: false,
    combined: false,
  });

  useEffect(() => {
    if (props.knowledgeBase.id) {
      setTabDisable((prev) => ({
        ...prev,
        document: props.knowledgeBase.type === KnowledgeBaseTypeEnum.PDF ? false : true,
        website: props.knowledgeBase.type === KnowledgeBaseTypeEnum.WEBSITE ? false : true,
        combined: props.knowledgeBase.type === KnowledgeBaseTypeEnum.COMBINED ? false : true,
      }));
      const tabId = Number(
        Object.keys(knowledgeBaseType).find(
          (key) => knowledgeBaseType[Number(key)] === props.knowledgeBase.type
        )
      );
      props.setKnowledgeBase((preVal) => {
        return {
          ...preVal,
          type: props.knowledgeBase.type
        }
      });
      setActiveTab(tabId);
    }
  }, [props.knowledgeBase]);






  const handleSwitchTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
    props.setKnowledgeBase((preVal) => {
      return {
        ...preVal,
        type: knowledgeBaseType[tabIndex]
      }
    });
  };



  return (
    <Box>
      <Box>
        <Typography variant="body1" fontWeight={500}>
          Source
        </Typography>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={activeTab}
          onChange={(e) => handleSwitchTab(Number(e.target.value))}
        >
          <FormControlLabel
            value="0"
            control={<Radio />}
            label="Document"
            disabled={tabDisable.document}
          />
          <FormControlLabel
            value="1"
            control={<Radio />}
            label="Website"
            disabled={tabDisable.website}
          />
          <FormControlLabel
            value="2"
            control={<Radio />}
            label="Combined"
            disabled={tabDisable.combined}
          />
        </RadioGroup>
        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && (
            <DocumentTab setKnowledgeBaseDoc={props.setKnowledgeBaseDoc} />
          )}
          {activeTab === 1 && (
            <WebsiteTab
              setKnowledgeBaseWebsite={props.setKnowledgeBasWebsite}
              knowledgeBase={props.knowledgeBase}
            />
          )}
          {activeTab === 2 && (
            <CombinedTab
              setKnowledgeBaseCombine={props.setKnowledgeBaseCombine}
              knowledgeBaseCombine={props.knowledgeBaseCombine}
              knowledgeBase={props.knowledgeBase}
              onSwitchToDocumentTab={handleSwitchTab}
            />
          )}
        </Box>
      </Box>

    </Box>
  );
};

export default KnowledgeBaseTabs;
